export const styles = {
  multiLineInput: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  multiLineFormGroup: {
    marginBottom: 0,
  },
  hidden: {
    display: 'none',
  },
};
